export default __webpack_public_path__ + "static/icon-aa1ad6808de93c306b37ce166cda823c.png";